import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const KeyboardWrapper = styled.div`
  color: ${Colors.commons.darkGray};
`;